import { useState } from 'react';
import { registerMutation, useMutation } from 'data-fetching-client';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import http from 'hub-http/clients/apiClient';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
const CLONE_FORM_FIELD_NAME = 'clonedForm';
const CLONE_FORM = registerMutation({
  fieldName: CLONE_FORM_FIELD_NAME,
  args: ['businessUnitId', 'guid', 'embedVersion', 'formType', 'name'],
  fetcher({
    businessUnitId,
    formType,
    embedVersion,
    guid,
    name
  }) {
    if (embedVersion === EmbedVersions.V4) {
      return http.post('hubspot-forms/v1/form/clone', {
        data: {
          originalFormId: guid,
          name,
          businessUnitId
        }
      });
    }
    switch (formType) {
      case FormTypes.FLOW:
        return http.post(`lead-flows/v1/lead-flows/${guid}/clone`, {
          data: {
            name,
            businessUnitId
          }
        });
      default:
        return http.post(`forms/v2/forms/${guid}/clone`, {
          data: {
            name,
            businessUnitId
          }
        });
    }
  }
});
export default function useCloneForm() {
  const [error, setError] = useState(undefined);
  const [cloneForm, {
    loading
  }] = useMutation(CLONE_FORM, {
    onError: response => {
      setError(response);
      throw response;
    }
  });
  return {
    cloneForm: variables => cloneForm({
      variables
    }).then(response => response.data ? response.data.clonedForm : undefined).catch(cloneError => {
      cloneError.cause = 'CLONE_ERROR';
      throw cloneError;
    }),
    clearError: () => {
      setError(undefined);
    },
    error,
    loading
  };
}